import Swiper from "swiper";
import { Autoplay, Navigation, EffectFade, Pagination } from "swiper/modules";

const initSwiper = () => {
  const carouselContainers = document.querySelectorAll(".carousel-swiper");

  carouselContainers.forEach((container) => {
    const carousel = container.querySelector(".swiper");
    const parentContainer = carousel.parentElement;
    const arrowPrev = parentContainer.querySelector(".swiper-button-prev");
    const arrowNext = parentContainer.querySelector(".swiper-button-next");

    // Get ACF field values from data attributes
    const type = container.dataset.type || "fade";
    const autoplay = container.dataset.autoplay !== "0";
    const slidesPerViewMobile = parseInt(container.dataset.slidesperviewMobile, 10) || 1;
    const slidesPerViewDesktop = parseInt(container.dataset.slidesperviewDesktop, 10) || 1;
      const counter = container.dataset.showCounter !== "0";

      const arrowsPosition = container.dataset.arrows || "bottom";

    const slidesCount = carousel.querySelectorAll(".swiper-slide").length;

    // Handle arrows visibility based on slides count
    if (slidesCount <= 1) {
      arrowPrev.style.display = "none";
      arrowNext.style.display = "none";
    }

    // Apply arrows position class
    if (arrowsPosition === "middle") {
      parentContainer.querySelector(".swiper-arrows").classList.add("middle-position");
    }

    // Configure Swiper options based on data attributes
    const swiperOptions = {
      modules: [Autoplay, Navigation, EffectFade, Pagination],
      loop: slidesCount > 1,
      speed: 800,
      navigation: {
        nextEl: arrowNext,
        prevEl: arrowPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: slidesPerViewMobile,
        },
        792: {
          slidesPerView: slidesPerViewDesktop,
        }
      }
    };

    // Add effect options based on type
    if (type === "fade") {
      swiperOptions.effect = "fade";
      swiperOptions.fadeEffect = {
        crossFade: true,
      };
    }

    if(counter) {
      swiperOptions.pagination = {
        el: parentContainer.querySelector(".swiper-pagination"),
        type: "fraction",
      };
    }

    // Add autoplay if enabled
    if (autoplay) {
      // swiperOptions.autoplay = {
      //   delay: 8000,
      //   disableOnInteraction: false,
      // };
    }

    // Initialize Swiper with the configuration
    new Swiper(carousel, swiperOptions);
  });
};

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", initSwiper);
